import { InfoRestauranteComponent } from './components/establecimiento/info-restaurante/info-restaurante.component';
import { PaginaPlatoComponent } from './components/establecimiento/pagina-plato/pagina-plato.component';
import { PaginaProductoComponent } from './components/marca/pagina-producto/pagina-producto.component';
import { PaginaBarComponent } from './components/establecimiento/pagina-bar/pagina-bar.component';
import { PaginaUsuarioComponent } from './components/pagina-usuario/pagina-usuario.component';
import { InfoUsuarioComponent } from './components/info-usuario/info-usuario.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapaComponent } from './components/mapa/mapa.component';
import { MapaMarcaComponent } from './components/mapa-marca/mapa-marca.component';
import { BuscadorComponent } from './components/buscador/buscador.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { SeccionCategoriasComponent } from './components/seccion-categorias/seccion-categorias.component';
import { SliderRangeComponent } from './components/slider-range/slider-range.component';
import { ReservasComponent } from './components/reservas/reservas.component';
import { LoginComponent } from './components/login/login.component';
import { RegistrarseComponent } from './components/registrarse/registrarse.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { EditarPerfilComponent } from './components/editar-perfil/editar-perfil.component';
import { IsLoginGuard } from './guards/is-login.guard';
import { PublicacionComponent } from './components/publicacion/publicacion.component';
import { RecuperarPassComponent } from './components/recuperar-pass/recuperar-pass.component';
import { CreatePageComponent } from './components/create-page/create-page.component';
import { RatingComponent } from './components/rating/rating.component';
import { CarritoComponent } from './components/carrito/carrito.component';
import { PagoOkComponent } from './components/pago-ok/pago-ok.component';
import { PagoErrorComponent } from './components/pago-error/pago-error.component';
import { PedidoComponent } from './components/pedido/pedido.component';
import { PaginaMarcaComponent } from './components/marca/pagina-marca/pagina-marca.component';
import { PaginaEstablecimientoComponent } from './components/establecimiento/pagina-establecimiento/pagina-establecimiento.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'buscador',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'login/:marca',
    component: LoginComponent
  },
  {
    path: 'registrarse',
    component: RegistrarseComponent
  },
  {
    path: 'mapa',
    component: MapaComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'mapa-marca/:marca',
    component: MapaMarcaComponent,
    //canActivate:[IsLoginGuard]
  },
  {
    path: 'perfil',
    component: PerfilComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'rating',
    component: RatingComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'editar-perfil',
    component: EditarPerfilComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'create-page',
    component: CreatePageComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'buscador',
    component: BuscadorComponent
  },
  {
    path: 'buscador/:hashtag',
    component: BuscadorComponent
  },
  {
    path: 'infobox',
    component: InfoBoxComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'seccion-categorias',
    component: SeccionCategoriasComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'slider-range',
    component: SliderRangeComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'pedido',
    component: PedidoComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'establecimiento/:slug',
    // path: 'restaurante/:id',
    component: PaginaEstablecimientoComponent,
    data: { tipo: 'establecimiento', seccion: 'carta' }
  },
  {
    path: 'establecimiento/:slug/info',
    // path: 'restaurante/:id/info',
    component: PaginaEstablecimientoComponent,
    data: { tipo: 'establecimiento', seccion: 'info' }
  },
  {
    // path: 'restaurante/:slug/cartaQR',
    path: 'establecimiento/:id/cartaQR',
    component: PaginaBarComponent
  },
  {
    path: 'restauranteQR/:id',
    component: PaginaBarComponent,
  },
  {
    path: 'restauranteQR/:id/info',
    component: InfoRestauranteComponent,
  },
  {
    path: 'platoQR/:id',
    component: PaginaPlatoComponent,
  },
  {
    path: 'fabricante/:slug',
    // path: 'fabricante/:id',
    component: PaginaMarcaComponent,
    data: { tipo: 'marca', seccion: 'tienda' }
  },
  {
    path: 'fabricante/:slug/info',
    // path: 'fabricante/:id/info',
    component: PaginaMarcaComponent,
    data: { tipo: 'marca', seccion: 'info' }
  },
  {
    path: 'plato/:slug',
    // path: 'plato/:id',
    component: PaginaEstablecimientoComponent,
    data: { tipo: 'plato' }
  },
  {
    path: 'producto/:slug',
    // path: 'producto/:id',
    component: PaginaMarcaComponent,
    data: { tipo: 'producto' }
  },
  {
    path: 'producto/:slug/tags',
    // path: 'producto/:id/tags',
    component: PaginaProductoComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'usuario/:slug',
    // path: 'usuario/:id',
    component: InfoUsuarioComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'publicacion/:slug',
    // path: 'publicacion/:id',
    component: PaginaUsuarioComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'establecimiento/:slug/reserva',
    // path: 'restaurante/:id/reserva',
    component: ReservasComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'publicacion',
    component: PublicacionComponent,
    canActivate: [IsLoginGuard]
  },
  {
    path: 'recuperar',
    component: RecuperarPassComponent,
  },
  {
    path: 'carrito',
    component: CarritoComponent,
  },
  {
    path: 'pagoOk',
    component: PagoOkComponent,
  },
  {
    path: 'pagoError',
    component: PagoErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
